var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVioletT = function SvgVioletT(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163,
    height: 189,
    viewBox: "0 0 163 189",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "20.438%",
    x2: "79.091%",
    y1: "27.297%",
    y2: "82.542%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M258.116 74.708c-42.19 52.946-11.179 142.326-138.61 177.012C-7.926 286.407-20.634 402.336 21.984 476.7c42.62 74.363 148.676 98.832 224.552 76.16 56-16.734 75.84-58.405 137.39-98.532 61.552-40.126 65.64-29.611 145.717-80.85 52.864-33.827 62.323-101.803 60.051-137.603C582.08 115.824 491.52-.01 390.236 0c-43.988.005-90.01 21.86-132.12 74.708"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "20.438%",
    x2: "79.091%",
    y1: "43.625%",
    y2: "59.137%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9,
    transform: "translate(0 -371)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M71 528.244c51.006 33.8 121.426 41.988 176.147 25.594 56.008-16.78 75.851-58.567 137.412-98.806 36.872-24.1 53.126-29.983 77.441-41.865C419.736 382.911 367.304 365 310.51 365 199.68 365 105.461 433.205 71 528.244",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVioletT);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/violet-t.124ba90820764ffe337b23cc7c5414ab.svg";